function getAdmissionsPie(){
    var customDimension = function(){
        return ndx.dimension(function(d){
            var sorted = Object.keys(d.financial_change).sort(function(a,b){return b - a});
            return d.financial_change[sorted[0]];
        });
    }
    financialPie(admissionsChart, function(){getAdmissionsTip()}, undefined, customDimension);
}

function getDischargesPie(){
    var customDimension = function(){
        return ndx.dimension(function(d){
            var sorted = Object.keys(d.financial_change).sort(function(a,b){return b - a});
            return d.financial_change[sorted[0]];
        });
    }
    financialPie(dischargesChart, function(){getDischargesTip()}, undefined, customDimension);
}

function getFinancialPie(){
    var customDimension = function(){
        return ndx.dimension(function(d){
            if(mainGraphFilter == 'discharges'){
                var sorted = Object.keys(d.financial_change).sort(function(a,b){return b - a});
            }else{
                var sorted = Object.keys(d.financial_change).sort(function(a,b){return b - a});
            }
            return d.financial_change[sorted[0]];
        });
    }
	financialPie(financialChart, function(){getPieTip()}, undefined, customDimension);
}

function getLengthOfStayPie(){
    var renderlet = function(chart){
        var pieSlices = chart.selectAll('.pie-slice');
        pieSlices[0].forEach(function(d, i){
            d = d3.select(d);
            var path = d.select('path');
            if(path.attr('d') == 'M0,0'){
                chart.select('g')
                    .append('g').attr('class', 'pie-slice _'+(i+1)).append('path').attr('class', 'disabled').attr('fill', '#E6E6E6').attr('d', 'M0,47.5A47.5,47.5 0 1,1 0,-47.5A47.5,47.5 0 1,1 0,47.5Z');
            }
        });
        if(mainGraphFilter != 'lengthofstay'){
            chart.selectAll('.pie-slice').on("click", function(d){
                $('.mainFilter[data-filter="lengthofstay"]').click();
            });
        }
        if(chart.dimension().top(Infinity).length === 0){
            chart.select('g').append('g').classed('pie-slice _1', true).append('path').classed('disabled', true).attr('fill', '#E6E6E6').attr('d', 'M0,47.5A47.5,47.5 0 1,1 0,-47.5A47.5,47.5 0 1,1 0,47.5Z');
        }
        var d3Pie = chart.svg()[0];
        d3Pie.sort();
    }

    var customDimension = function(){
        if(mainGraphFilter != 'lengthofstay'){
            losNDX = crossfilter(removeDataForLOS(true));
            return losNDX.dimension(function(d){
                var sorted = Object.keys(d.financial_change).sort(function(a,b){return b - a});
                return d.financial_change[sorted[0]];
            });
        }else{
            return ndx.dimension(function(d){
                var sorted = Object.keys(d.financial_change).sort(function(a,b){return b - a});
                return d.financial_change[sorted[0]];
            });
        }
    }

    var reduceFunctions = {
        add: function(p,v){
            p.count++;
            p.los += v.LOS;
            p.avgLOS = p.count ? (p.los / p.count) : 0;
            return p;
        },
        subtract: function(p,v){
            p.count--;
            p.los -= v.LOS;
            p.avgLOS = p.count ? (p.los / p.count) : 0;
            return p;
        },
        defaultVars: function(){
            return{
                count: 0,
                los: 0,
                avgLOS: 0
            }
        }
    }

    financialPie(lengthofstayChart, function(){
        if(lengthofstayChart.dimension().top(Infinity).length !== 0){
            getLengthOfStayTip();
        }
    }, renderlet, customDimension, reduceFunctions, function(d){return d.value.avgLOS;});
}

function getLengthOfStayTotalPie(){
    var renderlet = function(chart){
        var pieSlices = chart.selectAll('.pie-slice');
        pieSlices[0].forEach(function(d, i){
            d = d3.select(d);
            var path = d.select('path');
            if(path.attr('d') == 'M0,0'){
                chart.select('g')
                    .append('g').attr('class', 'pie-slice _'+(i+1)).append('path').attr('class', 'disabled').attr('fill', '#E6E6E6').attr('d', 'M0,47.5A47.5,47.5 0 1,1 0,-47.5A47.5,47.5 0 1,1 0,47.5Z');
            }
        });
        if(mainGraphFilter != 'lengthofstaytotal'){
            chart.selectAll('.pie-slice').on("click", function(d){
                $('.mainFilter[data-filter="lengthofstaytotal"]').click();
            });
        }
        if(chart.dimension().top(Infinity).length === 0){
            chart.select('g').append('g').classed('pie-slice _1', true).append('path').classed('disabled', true).attr('fill', '#E6E6E6').attr('d', 'M0,47.5A47.5,47.5 0 1,1 0,-47.5A47.5,47.5 0 1,1 0,47.5Z');
        }
        var d3Pie = chart.svg()[0];
        d3Pie.sort();
    }

    var customDimension = function(){
        if(mainGraphFilter != 'lengthofstaytotal'){
            losNDX = crossfilter(removeDataForLOS(true));
            return losNDX.dimension(function(d){
                var sorted = Object.keys(d.financial_change).sort(function(a,b){return b - a});
                return d.financial_change[sorted[0]];
            });
        }else{
            return ndx.dimension(function(d){
                var sorted = Object.keys(d.financial_change).sort(function(a,b){return b - a});
                return d.financial_change[sorted[0]];
            });
        }
    }

    var reduceFunctions = {
        add: function(p,v){
            p.count++;
            p.los += v.LOS;
            p.avgLOS = p.count ? (p.los / p.count) : 0;
            return p;
        },
        subtract: function(p,v){
            p.count--;
            p.los -= v.LOS;
            p.avgLOS = p.count ? (p.los / p.count) : 0;
            return p;
        },
        defaultVars: function(){
            return{
                count: 0,
                los: 0,
                avgLOS: 0
            }
        }
    }

    financialPie(lengthofstaytotalChart, function(){
        if(lengthofstaytotalChart.dimension().top(Infinity).length !== 0){
            getLengthOfStayTotalTip();
        }
    }, renderlet, customDimension, reduceFunctions, function(d){return d.value.los;});
}

function financialPie(chart, tipFunction, renderlet, customDimension, reduceFunctions, valueAccessor){
    renderlet = (renderlet != undefined ? renderlet : false);
    customDimension = (customDimension != undefined ? customDimension : false);
    reduceFunctions = (reduceFunctions != undefined ? reduceFunctions : false);
    valueAccessor = (valueAccessor != undefined ? valueAccessor : false);
    if(customDimension == false){
        var financialDimension = ndx.dimension(function(d){
              return d.financial;
        });
    }else{
        var financialDimension = customDimension();
    }
    var financialGroup = financialDimension.group();
    if(reduceFunctions != false){
        financialGroup.reduce(reduceFunctions.add, reduceFunctions.subtract, reduceFunctions.defaultVars);
    }
    chart
        .group(financialGroup)
        .dimension(financialDimension)
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);
    if(valueAccessor != false){
        chart.valueAccessor(function(d){return valueAccessor(d);});
    }
    if(renderlet != false){
        chart.renderlet(function(chart){renderlet(chart);});
    }else{
        var filter = $(chart.root()[0]).siblings('.menu-wrap').children('.mainFilter').attr('data-filter');
        chart.renderlet(function(chart){
            if(mainGraphFilter != filter){
                chart.selectAll('.pie-slice').on("click", function(d){
                    $('.mainFilter[data-filter="'+filter+'"]').click();
                });
            }
        });
    }
    tipFunction();
}

function getCensusPie(){
    var censusDimension = ndx.dimension(function(d){
        return d.financial;
    });
    var censusGroup = censusDimension.group().reduce(
        function(p,v){
            p.count++;
            p.adc = (p.count / bedCount) * 100;
            return p;
        },
        function(p,v){
            p.count--;
            p.adc = (p.count / bedCount) * 100;
            return p;
        },
        function(){
            return {
                count: 0,
                adc: 0
            };
        }
    );

    censusChart
        .group(censusGroup)
        .dimension(censusDimension)
        .valueAccessor(function(d){
            return d.value.adc;
        })
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors)
        .renderlet(function(chart){
            if(mainGraphFilter != 'riskadjusted'){
                chart.selectAll('.pie-slice').on("click", function(d){
                    $('.mainFilter[data-filter="census"]').click();
                });
            }
        });

    getCensusTooltip();
}
function getRawReadmissionsPie(){
    var fromOverwrite = undefined;
    if(isWithinMonth){
        fromOverwrite = $('#from').datepicker('getDate');
        fromOverwrite.setMonth(fromOverwrite.getMonth() - 1);
        var rawreadmissionDimension = twoMonthNDX.dimension(function(d){
            if(isWithinTimeRange(d.admit_dt, fromOverwrite)){
                return d3.time.month(d.admit_dt);
            }
        });
    }else{
        var rawreadmissionDimension = ndx.dimension(function(d){
            if(isWithinTimeRange(d.admit_dt)){
                return d3.time.month(d.admit_dt);
            }
        });
    }
    var rawreadmissionGroup = rawreadmissionDimension.group().reduce(
        function(p, v) {
            if(isWithinTimeRange(v.admit_dt, fromOverwrite)){
                ++p.count;
                p.readmits += (v.readmit == 1 ? 1 : 0);
                p.readmitPercent = p.count ? p.readmits/p.count : 0;
            }
            return p;
        },
        function(p, v) {
            if(isWithinTimeRange(v.admit_dt, fromOverwrite)){
                --p.count;
                p.readmits -= (v.readmit == 1 ? 1 : 0);
                p.readmitPercent = p.count ? p.readmits/p.count : 0;
            }
            return p;
        },
        function() {
            return {
                count: 0,
                readmits: 0,
                readmitPercent: 0
            };
        }
    );
    rawreadmissionChart
        .dimension(rawreadmissionDimension)
        .group(rawreadmissionGroup)
        .valueAccessor(function(d){
            return d.value.readmitPercent * 100;
        })
        .ordering(function(d){
            return -d3.time.month(d.key);
        })
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors)
        .renderlet(function(chart){
            var pieSlices = chart.selectAll('.pie-slice');
            pieSlices[0].forEach(function(d, i){
                d = d3.select(d);
                var path = d.select('path');
                if(path.attr('d') == 'M0,0' || path.attr('d') == 'M 0 0'){
                    chart.select('g')
                        .append('g').attr('class', 'pie-slice _'+(i+1)).append('path').attr('class', 'disabled').attr('fill', '#E6E6E6').attr('d', 'M0,47.5A47.5,47.5 0 1,1 0,-47.5A47.5,47.5 0 1,1 0,47.5Z');
                }
            });
            if(mainGraphFilter != 'rawreadmission'){
                chart.selectAll('.pie-slice').on("click", function(d){
                    $('.mainFilter[data-filter="rawreadmission"]').click();
                });
            }
        });

    getRawReadmissionTip();
}

function getRiskAdjustedPie(){
    var fromOverwrite = undefined;
    if(isWithinMonth){
        fromOverwrite = $('#from').datepicker('getDate');
        fromOverwrite.setMonth(fromOverwrite.getMonth() - 1);
        var riskadjustedDimension = twoMonthNDX.dimension(function(d){
            if(isWithinTimeRange(d.admit_dt, fromOverwrite)){
                return d3.time.month(d.admit_dt);
            }
        });
    }else{
        var riskadjustedDimension = ndx.dimension(function(d){
            if(isWithinTimeRange(d.admit_dt)){
                return d3.time.month(d.admit_dt);
            }
        });
    }
    var riskadjustedGroup = riskadjustedDimension.group().reduce(
        function(p, v) {
            if(isWithinTimeRange(v.admit_dt, fromOverwrite)){
                ++p.count;
                p.readmits += (v.readmit == 1 ? 1 : 0);
                p.riskAdjustPercent = p.count ? riskAdjustedRate((p.readmits/p.count), 0.195, 0.185) : 0;
            }
            return p;
        },
        function(p, v) {
            if(isWithinTimeRange(v.admit_dt, fromOverwrite)){
                --p.count;
                p.readmits -= (v.readmit == 1 ? 1 : 0);
                p.riskAdjustPercent = p.count ? riskAdjustedRate((p.readmits/p.count), 0.195, 0.185) : 0;
            }
            return p;
        },
        function() {
            return {
                count: 0,
                readmits: 0,
                riskAdjustPercent: 0
            };
        }
    );
    riskadjustedChart
        .dimension(riskadjustedDimension)
        .group(riskadjustedGroup)
        .valueAccessor(function(d){
            return d.value.riskAdjustPercent * 100;
        })
        .ordering(function(d){
            return -d3.time.month(d.key);
        })
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors)
        .renderlet(function(chart){
            var pieSlices = chart.selectAll('.pie-slice');
            pieSlices[0].forEach(function(d, i){
                d = d3.select(d);
                var path = d.select('path');
                if(path.attr('d') == 'M0,0' || path.attr('d') == 'M 0 0'){
                    chart.select('g')
                        .append('g').attr('class', 'pie-slice _'+(i+1)).append('path').attr('class', 'disabled').attr('fill', '#E6E6E6').attr('d', 'M0,47.5A47.5,47.5 0 1,1 0,-47.5A47.5,47.5 0 1,1 0,47.5Z');
                }
            });
            if(mainGraphFilter != 'riskadjusted'){
                chart.selectAll('.pie-slice').on("click", function(d){
                    $('.mainFilter[data-filter="riskadjusted"]').click();
                });
            }
        });

    getRiskAdjustedTip();
}

function getPhysicianPie(){
    var physicianDimension = ndx.dimension(function(d){
        return d.doctor;
    });
    var physicianGroup = physicianDimension.group();

    physicianChart
        .dimension(physicianDimension)
        .group(physicianGroup)
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .slicesCap(8)
        .renderlet(function(chart){
            $(chart.svg()[0]).css('overflow','visible');
            chart.selectAll('.pie-slice').on("click", function(d){
                if(mainGraphFilter != 'physician'){
                    $('.mainFilter[data-filter="physician"]').click();
                }
                if(d.data.key == 'Others'){
                    var filterWrap = $(physicianChart.root()[0]).parent();
                    if($(filterWrap).hasClass('others')){
                        $(this).children('path').attr('stroke', 'black').attr('stroke-opacity', '0').attr('stroke-width', '0px');
                        $(filterWrap).removeClass('others');
                        originOthersPie = null;
                        $(filterWrap).find('.otherChart').animate({height: 0}, 300, function(){$(this).remove();});
                        physicianChart.filterAll();
                        dc.redrawAll();
                    }else{
                        $(this).children('path').attr('stroke', 'black').attr('stroke-opacity', '0.5').attr('stroke-width', '1px');
                        $(filterWrap).addClass('others');
                        createPhysiciansOtherPie(filterWrap, d.data.others);
                        physicianChart.filterAll();
                        dc.redrawAll();
                    }
                }
            });
        })
        .colors(colors);

    getPhysicianTip();

    
}

function getCompareStarPie(){
    var filter = 'overall_rating';
    compareStarRatings.forEach(function(d){
        if(d.selected){
            filter = d.key;
        }
    });
    if(nearbyRange == 'federal' || nearbyRange == 'state'){
        var compareStarDimenision = compareOtherNDX.dimension(function(d){
            return parseFloat(d[filter]).toFixed(0);
        });
    }else{
        var compareStarDimenision = compareNDX.dimension(function(d){
            return parseFloat(d[filter]).toFixed(0);
        });
    }
    var compareStarGroup = compareStarDimenision.group();

    var compareColors = colors.slice();
    compareColors.shift();

    compareStarPie
        .dimension(compareStarDimenision)
        .group(compareStarGroup)
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(compareColors);

    getCompareStarTip();
}

function getCompareDefPie(){
    var compareDefDimension = compareNDX.dimension(function(d){

    });
    var compareDefGroup = compareStarDimenision.group();

    compareDefPie
        .dimension(compareDefDimension)
        .group(compareDefGroup)
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(compareColors);
}

function getOriginPie(){
    var originDimension = ndx.dimension(function(d){
        return d.origin;
    });
    var originGroup = originDimension.group();

    originChart
        .dimension(originDimension)
        .group(originGroup)
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .slicesCap(8)
        .renderlet(function(chart){
            $(chart.svg()[0]).css('overflow','visible');
            chart.selectAll('.pie-slice').on("click", function(d){
                if(mainGraphFilter != 'origin'){
                    $('.mainFilter[data-filter="origin"]').click();
                }
                if(d.data.key == 'Others'){
                    var filterWrap = $(originChart.root()[0]).parent();
                    if($(filterWrap).hasClass('others')){
                        $(this).children('path').attr('stroke', 'black').attr('stroke-opacity', '0').attr('stroke-width', '0px');
                        $(filterWrap).removeClass('others');
                        originOthersPie = null;
                        $(filterWrap).find('.otherChart').animate({height: 0}, 300, function(){$(this).remove();});
                        originChart.filterAll();
                        dc.redrawAll();
                    }else{
                        $(this).children('path').attr('stroke', 'black').attr('stroke-opacity', '0.5').attr('stroke-width', '1px');
                        $(filterWrap).addClass('others');
                        createOriginOthersPie(filterWrap, d.data.others);
                        originChart.filterAll();
                        dc.redrawAll();
                    }
                }
            });
        })
        .colors(colors);

    getOriginTip();
}

function getDiagnosisPie(){
    var diagnosesDimension = ndx.dimension(function(d){
        return d.diagnosis;
    });
    var diagnosesGroup = diagnosesDimension.groupAll().reduce(
        function(p, v) {
            if((mainGraphFilter == 'rawreadmission' || mainGraphFilter == 'riskadjusted') && v.readmit == "0"){
                return p;
            }
            v.diagnosis.forEach(function(val){
                p[val.DIAGNOSIS_CODE] = (p[val.DIAGNOSIS_CODE] || {});
                p[val.DIAGNOSIS_CODE].count = (p[val.DIAGNOSIS_CODE].count || 0) + 1;
                p[val.DIAGNOSIS_CODE].description = (val.DIAGNOSIS_DESCRIPTION != undefined ? val.DIAGNOSIS_DESCRIPTION : 'Unknown');
                p[val.DIAGNOSIS_CODE].icdVersion = val.CODING_METHOD;
            });
            return p;
        },
        function(p, v) {
            v.diagnosis.forEach(function(val){
                if(val.DIAGNOSIS_CODE in p){
                    p[val.DIAGNOSIS_CODE].count = (p[val.DIAGNOSIS_CODE].count || 0) - 1;
                }
            });
            return p;
        },
        function(p, v) {
            return {};
        }
    );
    diagnosesGroup = diagnosesGroup.value();
    diagnosesGroup.all = function() {
        var newObject = [];
        for (var key in this){
            if(this.hasOwnProperty(key) && key != 'None' && key != "all" && key != 'top') {
                newObject.push({
                    key: key,
                    value: this[key]
                });
            }
        }
        return newObject;
    }
    diagnosesGroup.top = function(count) {
        var newObject = this.all();
        newObject.sort(function(a, b){return b.value - a.value});
        return newObject.slice(0, count);
    };
    diagnosisChart
        .dimension(diagnosesDimension)
        .group(diagnosesGroup)
        .valueAccessor(function(d){
            return d.value.count;
        })
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);
    diagnosisChart
        .filterHandler(function(dimension, filters){
            if(filters.length === 0 || filters[0] == undefined) {
                dimension.filter(null);
            }else{
                dimension.filterFunction(function(d){
                    for(var i = 0; i < d.length; i++){
                        if(filters.indexOf(d[i].DIAGNOSIS_CODE) > -1){
                            return true;
                        }
                    }
                    return false; 
                });
            }
            return filters; 
        });

    getDiagnosisTip();
}

function buildArcs(chart) {
    return d3.svg.arc().outerRadius(chart.radius()).innerRadius(chart.innerRadius());
}

function labelPosition(d, arc) {
    var centroid = arc.centroid(d);
    if (isNaN(centroid[0]) || isNaN(centroid[1])) {
        return [0,0];
    } else {
        return centroid;
    }
}

function getDeficienciesPie(){
    var deficiencyDimension = deficienciesNDX.dimension(function(d){
        return d.letter;
    });
    var deficiencyGroup = deficiencyDimension.group();

    deficiencyChart
        .dimension(deficiencyDimension)
        .group(deficiencyGroup)
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);
    deficiencyChart
        .renderlet(function(chart){
            chart.selectAll('.pie-slice').on("click", function(d){
                if(mainGraphFilter != 'deficiencies'){
                    $('.mainFilter[data-filter="deficiencies"]').click();
                }
            });
        });

   
    var ftagDimension = deficienciesNDX.dimension(function(d){
        return d.tag;
    });
    var ftagGroup = ftagDimension.group();

    ftagChart
        .dimension(ftagDimension)
        .group(ftagGroup)
        .width(95)
        .height(95)
        .slicesCap(8)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);

    var regulationDimension = deficienciesNDX.dimension(function(d){
        return d.regulation;
    });
    var regulationGroup = regulationDimension.group();
    regulationChart
        .dimension(regulationDimension)
        .group(regulationGroup)
        .width(95)
        .height(95)
        .slicesCap(8)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);

    var categoryDimension = deficienciesNDX.dimension(function(d){
        return d.department;
    });
    var categoryGroup = categoryDimension.group();
    categoryChart
        .dimension(categoryDimension)
        .group(categoryGroup)
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);

    getDeficienciesTip();
}


function getSurveysPie(){
    var surveyDimension = surveyNDX.dimension(function(d){
        return d.answers;
    });
    
    var surveyGroup = surveyDimension.groupAll().reduce(
        function(p, v) {
            for(var answer in v.answers){
                p[v.answers[answer]] = (p[v.answers[answer]] || 0) + 1;
            }
            return p;
        },
        function(p, v) {
           for(var answer in v.answers){
                p[v.answers[answer]] = (p[v.answers[answer]] || 0) - 1; 
            }
            return p;
        },
        function(p, v) {
            return {};
        }
    );
    surveyGroup = surveyGroup.value();
    surveyGroup.all = function() {
        var newObject = [];
        for (var key in this){
            if(this.hasOwnProperty(key) && key != 'all') {
                newObject.push({
                    key: key.toString(),
                    value: this[key]
                });
            }
        }
        return newObject;
    }
   
    surveyChart
        .dimension(surveyDimension)
        .group(surveyGroup)
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);

    surveyChart
        .renderlet(function(chart){
            chart.selectAll('.pie-slice').on("click", function(d){
                if(mainGraphFilter != 'surveys'){
                    $('.mainFilter[data-filter="surveys"]').click();
                }
            });
        });

    surveyChart
        .filterHandler (function (dimension, filters){
                var groupVal = mainChart.dimension().bottom(Infinity);
                var allStacks = [];
                if(mainChart.allGroups == undefined){
                    mainChart.group().all().forEach(function(d){
                        allStacks.push(d);
                    });
                }else{
                    mainChart.allGroups().forEach(function(d, i){
                        d.all().forEach(function(a){
                            allStacks.push(a);
                        })
                    });
                }
                allStacks.forEach(function(d, i){
                    d.value.total = window.originalData[i];
                });

                dimension.filter(null);   
                if(filters.length === 0){
                    dimension.filter(null);
                }
                else{
                    allStacks.forEach(function(d){
                        if(filters.indexOf(d.value.type.toString()) === -1){
                           d.value.total = 0;
                        }
                    });
                    dimension.filterFunction(function (d){
                        for (var i=0; i < d.length; i++) {
                            if(filters.indexOf(d[i]) >= 0){
                                return true;
                            }
                        }
                        return true;
                    });
                }
                return filters;
            }
        );

    var ftagSurveyDimension = surveyNDX.dimension(function(d){
        return 'SV-'+d.ind_dep_count;
    });
    var ftagSurveyGroup = ftagSurveyDimension.group();

    ftagSurveyChart
        .dimension(ftagSurveyDimension)
        .group(ftagSurveyGroup)
        .width(95)
        .height(95)
        .slicesCap(8)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);

    var regulationSurveyDimension = surveyNDX.dimension(function(d){
        return d.regulation;
    });
    var regulationSurveyGroup = regulationSurveyDimension.group();
    regulationSurveyChart
        .dimension(regulationSurveyDimension)
        .group(regulationSurveyGroup)
        .width(95)
        .height(95)
        .slicesCap(8)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);

    getSurveysTip();
}

function getQISPie(){
    var qisDimension = qisNDX.dimension(function(d){
        return d.answers;
    });
    
    var qisSurveyGroup = qisDimension.groupAll().reduce(
        function(p, v) {
            for(var answer in v.answers){
                p[v.answers[answer]] = (p[v.answers[answer]] || 0) + 1;
            }
            return p;
        },
        function(p, v) {
           for(var answer in v.answers){
                p[v.answers[answer]] = (p[v.answers[answer]] || 0) - 1; 
            }
            return p;
        },
        function(p, v) {
            return {};
        }
    );
    qisSurveyGroup = qisSurveyGroup.value();
    qisSurveyGroup.all = function() {
        var newObject = [];
        for (var key in this){
            if(this.hasOwnProperty(key) && key != 'all') {
                newObject.push({
                    key: key.toString(),
                    value: this[key]
                });
            }
        }
        return newObject;
    }
    
    qisChart
        .dimension(qisDimension)
        .group(qisSurveyGroup)
        .width(95)
        .height(95)
        .renderLabel(false)
       /* .label(function(d){
            if(d.data.key == "1"){
                return "YES";
            }else if(d.data.key == "2"){
                return "NO";
            }
        })*/
        .renderTitle(false)
        .colors(colors);

    qisChart
        .renderlet(function(chart){
            chart.selectAll('.pie-slice').on("click", function(d){
                if(mainGraphFilter != 'qis'){
                    $('.mainFilter[data-filter="qis"]').click();
                }
            });
        });
    
    qisChart
        .filterHandler (function (dimension, filters){
                var groupVal = mainChart.dimension().bottom(Infinity);
                var allStacks = [];
                if(mainChart.allGroups == undefined){
                    mainChart.group().all().forEach(function(d){
                        allStacks.push(d);
                    });
                }else{
                    mainChart.allGroups().forEach(function(d, i){
                        d.all().forEach(function(a){
                            allStacks.push(a);
                        })
                    });
                }
                allStacks.forEach(function(d, i){
                    d.value.total = window.originalQISData[i];
                });

                dimension.filter(null);   
                if(filters.length === 0){
                    dimension.filter(null);
                }
                else{
                    allStacks.forEach(function(d){
                        if(filters.indexOf(d.value.type.toString()) === -1){
                           d.value.total = 0;
                        }
                    });
                    dimension.filterFunction(function (d){
                        for (var i=0; i < d.length; i++) {
                            if(filters.indexOf(d[i]) >= 0){
                                return true;
                            }
                        }
                        return true;
                    });
                }
                return filters;
            }
        );

    var ftagQISDimension = qisNDX.dimension(function(d){
        return 'SV-'+d.ind_dep_count;
    });
    var ftagQISGroup = ftagQISDimension.group();

    ftagQISChart
        .dimension(ftagQISDimension)
        .group(ftagQISGroup)
        .width(95)
        .height(95)
        .slicesCap(8)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);

    var regulationQISDimension = qisNDX.dimension(function(d){
        return d.regulation;
    });
    var regulationQISGroup = regulationQISDimension.group();
    regulationQISChart
        .dimension(regulationQISDimension)
        .group(regulationQISGroup)
        .width(95)
        .height(95)
        .slicesCap(8)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors);

    getQISTip();
}

function createOriginOthersPie(filterWrap, others){
    $(filterWrap).append('<div id="originOther-chart" class="otherChart" style="margin-top: 5px;"></div><span class="otherChart" style="display: block;">OTHERS</span>');
    originOthersPie = dc.pieChart('#originOther-chart');
    var otherDimension = originChart.dimension();
    var currentSlices = [];
    originChart.selectAll('.pie-slice').each(function(d, i){
        currentSlices.push(d.data.key);
    });

    var otherGroup = otherDimension.group();
    originOthersPie
        .dimension(otherDimension)
        .group(otherGroup)
        .valueAccessor(function(d){
            if(currentSlices.indexOf(d.key) === -1){
                return d.value;
            }else{
                return 0;
            }
        })
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors)
        .render();

    getOriginOthersTip(originOthersPie);
}

function createPhysiciansOtherPie(filterWrap, others){
    $(filterWrap).append('<div id="physicianOther-chart" class="otherChart" style="margin-top: 5px;"></div><span class="otherChart" style="display: block;">OTHERS</span>');
    physicianOthersChart = dc.pieChart('#physicianOther-chart');
    var otherDimension = physicianChart.dimension();
    var currentSlices = [];
    physicianChart.selectAll('.pie-slice').each(function(d, i){
        currentSlices.push(d.data.key);
    });

    var otherGroup = otherDimension.group();
    physicianOthersChart
        .dimension(otherDimension)
        .group(otherGroup)
        .valueAccessor(function(d){
            if(currentSlices.indexOf(d.key) === -1){
                return d.value;
            }else{
                return 0;
            }
        })
        .width(95)
        .height(95)
        .renderLabel(false)
        .renderTitle(false)
        .colors(colors)
        .render();

    getPhysicianOthersTip(physicianOthersChart);
}

$(document).on('click', '.filter svg', function(){
    var thisFilter = $(this).parent().siblings('a.mainFilter').data('filter');
    if(isRemovedAdmissions){
        if(thisFilter == 'rawreadmission' || thisFilter == 'riskadjusted' || thisFilter == 'lengthofstay' || thisFilter == 'lengthofstaytotal'){
            $(this).parent().siblings('a.mainFilter').click();
        }
    }
});

function diagnosesDataFormat(data){
    var formatted = [];
    $.each(data, function(index, value){
        if(!isBlank(value.description) && value.description != 'Unknown'){
            var set = {};
            var code = index;
            if(value.icdVersion == 'I10'){
                if(index.length > 3){
                    code = code.substr(0, 3)+'.'+code.substr(3, (code.length - 3))
                }
            }else{
                if(index.length == 3){
                    code = code.substr(0,2)+'.'+code.substr(2, index.length);
                }else if(index.length > 3){
                    code = code.substr(0,3)+'.'+code.substr(3, index.length);
                }
            }
            set['code'] = code;
            set['description'] = value.description;
            set['icdVersion'] = value.icdVersion;
            set['key'] = index;
            set['count'] = value.count;
            formatted.push(set);
        }
    });
    return formatted;
}

function ftagDataFormat(data){
    var formatted = [];
     $.each(data, function(index, value){
        if(!isBlank(value.key)){
            var set = {};
            set['ftag'] = value.key;
            set['indicators'] = value.value;
            set['key'] = value.key;
            formatted.push(set);
        }
     });
     return formatted;
}

function regulationDataFormat(data){
    var formatted = [];
     $.each(data, function(index, value){
        if(!isBlank(value.key)){
            var set = {};
            set['regulation'] = value.key;
            set['indicators'] = value.value;
            set['key'] = value.key;
            formatted.push(set);
        }
     });
     return formatted;
}

$('.filter .more').click(function(e){
    e.preventDefault();
    more = $(this).data('more');
    var html = '';
    var tableColumns,
        tableData,
        order;
    if(more == 'diagnosis'){
        html += '<p style="text-align: left; font-size: 20px;">Diagnoses</p><p style="margin-bottom: 6px;">Click on the row(s) you would like to filter by</p>';
        html += '<table id="moreTable"><thead>';
            html += '<tr><th width="15%">ICD</th><th width="15%">Code</th><th width="15%">Residents</th><th width="85%">Description</th><th width="0px"></th></tr>'
        html += '</thead><tbody></tbody></table>';

        html += '<p style="text-align: right; margin-top: 12px;"><button id="close">CANCEL</button> <button id="moreUpdate">UPDATE</button></p>';
        moreChart = diagnosisChart;
        popUpBlock(html);

        $('.pop_up').addClass('diagnosisPop');

        tableColumns = [
                                { "mData": "icdVersion", "width": "12%", "title": "ICD", "className": "text-center"},
                                { "mData": "code", "width": "13%", "title": "Code", "className": "text-center"},
                                { "mData": "count", "width": "20%", "title": "Residents", "className": "text-center"},
                                { "mData": "description", "width": "55%", "title": "Description"},
                                { "mData": "key", "width": "0px", "title": "", "className": "key display-none"}
                        ];
        tableData = diagnosesDataFormat(moreChart.group());

        var currentFilters = moreChart.filters();

        order = [[2, 'desc']];
    }else if(more == 'ftags'){
        html += '<p style="text-align: left; font-size: 20px;">FTAGS</p><p style="margin-bottom: 6px;">Click on the row(s) you would like to filter by</p>';
        html += '<table id="moreTable"><thead>';
            html += '<tr><th width="50%">FTAG</th><th width="50%">Indicator Count</th><th width="0px"></th></tr>'
        html += '</thead><tbody></tbody></table>';

        html += '<p style="text-align: right; margin-top: 12px;"><button id="close">CANCEL</button> <button id="moreUpdate">UPDATE</button></p>';
        moreChart = window[$(this).data('chart')];
        moreChartTitle = $(this).data('chart');
        popUpBlock(html);

        tableColumns = [
                                { "mData": "ftag", "width": "12%", "title": "FTAG", "className": "text-center"},
                                { "mData": "indicators", "width": "13%", "title": "Indicator Count", "className": "text-center"},
                                { "mData": "key", "width": "0px", "title": "", "className": "key display-none"}
                        ];
        tableData = ftagDataFormat(moreChart.group().all());

        var currentFilters = moreChart.filters();

        order = [[1, 'desc']];
    }else if(more == 'regulations'){
        html += '<p style="text-align: left; font-size: 20px;">Regulations</p><p style="margin-bottom: 6px;">Click on the row(s) you would like to filter by</p>';
        html += '<table id="moreTable"><thead>';
            html += '<tr><th width="50%">Regulation</th><th width="50%">Indicator Count</th><th width="0px"></th></tr>'
        html += '</thead><tbody></tbody></table>';

        html += '<p style="text-align: right; margin-top: 12px;"><button id="close">CANCEL</button> <button id="moreUpdate">UPDATE</button></p>';
        moreChart = window[$(this).data('chart')];
        moreChartTitle = $(this).data('chart');
        popUpBlock(html);

        tableColumns = [
                                { "mData": "regulation", "width": "12%", "title": "Regulation", "className": "text-center"},
                                { "mData": "indicators", "width": "13%", "title": "Indicator Count", "className": "text-center"},
                                { "mData": "key", "width": "0px", "title": "", "className": "key display-none"}
                        ];
        tableData = regulationDataFormat(moreChart.group().all());

        var currentFilters = moreChart.filters();

        order = [[1, 'desc']];
    }

    var table = $('#moreTable').DataTable({
        "columns": tableColumns,
        "order": order,
        "paginate": false,
        "lengthChange": false,
        "filter": false,
        "sort": true,
        "info": false,
        "autoWidth": false,
        "deferRender": true,
        "data": tableData,
        "destroy": true,
        "scrollY": "400px",
        "searching": true,
        "language": {
            "search": "_INPUT_",
            "searchPlaceholder": "SEARCH"
        },
        "scrollCollapse": true
    });

    
    currentFilters.forEach(function(d){
        $('#moreTable tbody td.key').each(function(_, value){
            if($(value).text() == d){
                $(value).parent().addClass('selected');
            }
        });
        //('#moreTable tbody td.key:contains("'+d+'")').parent().addClass('selected');
    });


    $('#moreTable tbody').on( 'click', 'tr', function(){
        $(this).toggleClass('selected');
    });

    $(document).on('click', '#close', function(){
        if(more == 'diagnosis'){
            if(moreChart.filters().length != 0){
                moreChart.filters().forEach(function(d){
                    if($('.filter.active').find('.sub-filters').find('a[data-trigger-filter="'+d+'"][data-chart-filter="diagnosisChart"]').length == 0){
                        $('.filter.active').find('.sub-filters').find('a[data-trigger-filter="more"][data-chart-filter="diagnosisChart"]').addClass('selected');
                    }
                });
            }
        }else if(more == 'ftags'){
            if(moreChart.filters().length != 0){
                moreChart.filters().forEach(function(d){
                    if($('.filter.active').find('.sub-filters').find('a[data-trigger-filter="'+d+'"][data-chart-filter="'+moreChartTitle+'"]').length == 0){
                        $('.filter.active').find('.sub-filters').find('a[data-trigger-filter="more"][data-chart-filter="'+moreChartTitle+'"]').addClass('selected');
                    }
                });
            }
        }else if(more == 'regulations'){
            if(moreChart.filters().length != 0){
                moreChart.filters().forEach(function(d){
                    if($('.filter.active').find('.sub-filters').find('a[data-trigger-filter="'+d+'"][data-chart-filter="'+moreChartTitle+'"]').length == 0){
                        $('.filter.active').find('.sub-filters').find('a[data-trigger-filter="more"][data-chart-filter="'+moreChartTitle+'"]').addClass('selected');
                    }
                });
            }
        }
        removePopUpAndOverlay();
    });

    $(document).on('click', '#moreUpdate', function(){
        var selected = table.rows('.selected').data();
        if(removedResidents.length != 0){
            removeResidentRefresh = true;
        }
        if(more == 'diagnosis'){
            moreChart.filterAll();
            var currentFilters = moreChart.filters();
            $.each(selected, function(index, val){
                if(currentFilters.indexOf(val.key) === -1){
                    moreChart.filter(val.key);
                }
            });
            if(moreChart.filters().length != 0){
                var keyToUse = [];
                moreChart.filters().forEach(function(d){
                    if($('.filter.active').find('.sub-filters').find('a[data-trigger-filter="'+d+'"][data-chart-filter="diagnosisChart"]').length == 0){
                        keyToUse.push(d);
                        //moreChart.filter(d);
                    }
                });
                subfilterClicked['diagnosisChart'] = {filter: keyToUse, chart: 'diagnosisChart', more: false};
                if(keyToUse != 'more'){
                    subfilterClicked['diagnosisChart'].more = true;
                    subfilterClicked['diagnosisChart'].used = false;
                }
            }else{
                moreChart.filter(null);
                subfilterClicked = {};
            }
        }else if(more == 'ftags'){
            moreChart.filterAll();
            var currentFilters = moreChart.filters();
            $.each(selected, function(index, val){
                if(currentFilters.indexOf(val.key) === -1){
                    moreChart.filter([val.key]);
                }
            });
            if(moreChart.filters().length != 0){
                var keyToUse = [];
                moreChart.filters().forEach(function(d){
                    if($('.filter.active').find('.sub-filters').find('a[data-trigger-filter="'+d+'"][data-chart-filter="'+moreChartTitle+'"]').length == 0){
                        keyToUse.push(d);
                        //moreChart.filter(d);
                    }
                });
                subfilterClicked[moreChartTitle] = {filter: keyToUse, chart: moreChartTitle, more: false};
                if(keyToUse != 'more'){
                    subfilterClicked[moreChartTitle].more = true;
                    subfilterClicked[moreChartTitle].used = false;
                }
            }else{
                moreChart.filter(null);
                subfilterClicked = {};
            }
        }else if(more == 'regulations'){
            moreChart.filterAll();
            var currentFilters = moreChart.filters();
            $.each(selected, function(index, val){
                if(currentFilters.indexOf(val.key) === -1){
                    moreChart.filter(val.key);
                }
            });
            if(moreChart.filters().length != 0){
                var keyToUse;
                moreChart.filters().forEach(function(d){
                    if($('.filter.active').find('.sub-filters').find('a[data-trigger-filter="'+d+'"][data-chart-filter="'+moreChartTitle+'"]').length == 0){
                        keyToUse = d;
                        moreChart.filter(d);
                    }
                });
                subfilterClicked[moreChartTitle] = {filter: keyToUse, chart: moreChartTitle, more: false};
                if(keyToUse != 'more'){
                    subfilterClicked[moreChartTitle].more = true;
                    subfilterClicked[moreChartTitle].used = false;
                }
            }else{
                moreChart.filter(null);
                subfilterClicked = {};
            }
        }
        dc.redrawAll();
        removePopUpAndOverlay();
    });

    return false;
});

$('.filter .edit').click(function(e){
    e.preventDefault();
    if($(this).attr('data-edit') == 'bedCount'){
        var html = '<label for="bed_count" style="text-align: left; font-size: 18px; color: #e5b143; width: 60%; display: inline-block;">Available Beds:</label>';
        html += '<input placeholder="0" type="number" id="bed_count" style="font-size: 16px; vertical-align: middle; box-sizing: border-box; text-indent: 5px; color: #727272; border: 1px solid #ccc; height: 32px; appearance: none; display: inline-block; width: 40%;" value="'+bedCount+'"/>';
        html += '<p style="text-align: center; margin-top: 12px;"><button id="close" onclick="removePopUpAndOverlay();">CANCEL</button> <button id="editBedCount">UPDATE</button></p>';
        popUpBlock(html, true);
    }

    $(document).on('click', '#editBedCount', function(){
        if(window.demoData){
            removePopUpAndOverlay();
            return;
        }
        passData = {
            bedCount: $('#bed_count').val()
        };
        if(usr_assoc_id != ''){
            passData['usr_assoc_id'] = usr_assoc_id;
        }
        $.post('/analytics/facility/bedcount', passData, function(data){
            bedCount = $('#bed_count').val();
            removePopUpAndOverlay();
            $('#setDates').click();
        }, 'json');
    });

    return false;
});

function wasFiltered(){
    dc.events.trigger(function(){
        setCorrectGraphInformation();
        getMainGraphTip();
        if(removedResidents.length > 0 && !removeResidentRefresh){
            graphData = graphData.concat(removedResidents);
            removedResidents = [];
            generateGraphs(true);
        }
        createResidentsTable();
    }, 500);
}